import { Flex, theme } from 'antd';
import { useTranslation } from 'react-i18next';
import { LoadingMessage } from './LoadingMessage';

/**
 * A page whose code is still on its way (D-073). The router shows it only once a page
 * has taken a second, and keeps it for at least half a second so it doesn't flicker.
 */
export function PageLoading() {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  return (
    <Flex justify="center" style={{ paddingBlock: token.paddingXL }}>
      <LoadingMessage delayMs={0}>{t('app.loading')}</LoadingMessage>
    </Flex>
  );
}
